import React, { useState, useRef } from "react";
import ClipLoader from "react-spinners/ClipLoader";
import { API_BASE_URL } from "../../config";

// const API_BASE_URL = "https://screening.fanisko.com";
// const API_BASE_URL = "http://127.0.0.1:8000";
export default function TryMe({ jobs = [] }) {
  const [selectedJobId, setSelectedJobId] = useState("");
  const [resumeFile, setResumeFile] = useState(null);
  const [dragActive, setDragActive] = useState(false);
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [loadingPhase, setLoadingPhase] = useState(0); // 0 = idle, 1 = loading(red), 2 = processing(yellow), 3 = success(green)
  const getLoadingColor = () => {
    switch (loadingPhase) {
      case 1: return "#dc3545"; // red
      case 2: return "#ffc107"; // yellow
      case 3: return "#28a745"; // green
      default: return "#236ef2"; // blue/default
    }
  };
  const waitForFinalScore = async (candidate_id, jobid) => {
    const maxAttempts = 20; // e.g. up to 20 attempts
    const delay = 2000; // 2 seconds
    for (let attempt = 1; attempt <= maxAttempts; attempt++) {
      const res = await fetch(
        // `https://screening.fanisko.com/api/get_final_score?candidate_id=${candidate_id}&job_id=${jobid}`
        `${API_BASE_URL}/api/get_final_score?candidate_id=${candidate_id}&job_id=${jobid}`
      );
      if (!res.ok) throw new Error("Failed to fetch final score");
      const data = await res.json();
      // Assume final scoring sets a numeric llm_score
      if (data.llm_score !== undefined && data.llm_score !== null) {
        return data;
      }
      // Wait before next poll
      await new Promise((r) => setTimeout(r, delay));
    }
    throw new Error("Final score not available within time");
  };

  const handleSubmit = async () => {
    if (!resumeFile || !selectedJobId) return;

    setLoadingPhase(1); // uploading (red)
    setMessage("");

    const formData = new FormData();
    formData.append("resume", resumeFile);
    formData.append("jobid", selectedJobId);
    const selectedJob = jobs.find((job) => (job.jobid || job._id) === selectedJobId);
    formData.append("jobrole", selectedJob?.jobrole || "");

    try {
      // const res = await fetch("https://screening.fanisko.com/api/resume-screening", {
      const res = await fetch(`${API_BASE_URL}/api/resume-screening`, {
        method: "POST",
        body: formData,
      });
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || "Submission failed");
      }

      setLoadingPhase(2); // backend processing (yellow)

      const data = await res.json();

      // Poll for final score completion
      await waitForFinalScore(data.candidate_id, selectedJobId);

      setLoadingPhase(3); // success (green)
      setMessage("Resume submitted successfully! You can view the score in the dashboard.");

      setSelectedJobId("");
      setResumeFile(null);
    } catch (err) {
      setMessage("Error: " + err.message);
      setLoadingPhase(0); // reset on error
    }
  };


  const handleFileChange = (e) => {
    setResumeFile(e.target.files[0]);
  };

  const onDrop = (e) => {
    e.preventDefault();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      setResumeFile(e.dataTransfer.files[0]);
    }
  };

  return (
    <div style={{
      maxWidth: 900,
      margin: "60px auto",
      background: "#fff",
      borderRadius: 14,
      padding: 36,
      boxShadow: "0 4px 24px #2175f52a"
    }}>
      {(loadingPhase === 1 || loadingPhase === 2) && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.15)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 3000,
          }}
        >
          <ClipLoader size={60} color={getLoadingColor()} />
          <span style={{
            marginLeft: 15,
            fontWeight: "bold",
            fontSize: 22,
            color: getLoadingColor(),
            userSelect: "none",
          }}>
            {loadingPhase === 1 ? "Uploading..." : "Processing..."}
          </span>
        </div>
      )}

      <h2 style={{ color: "#22326b", fontWeight: 700, marginBottom: 30 }}>Manual Candidate Resume Screening</h2>

      {/* Job Selector Box */}
      <div style={{
        marginBottom: 38,
        background: "#f7fbff",
        borderRadius: 11,
        boxShadow: "0 2px 10px #b3cff41f",
        padding: "28px 23px",
        border: "1.3px solid #cbe7ff",
        minWidth: 850,
        maxWidth: 420
      }}>
        <label style={{ fontWeight: 700, fontSize: 18, color: "#344" }}>Select Job</label>
        <select
          value={selectedJobId}
          onChange={e => setSelectedJobId(e.target.value)}
          style={{
            width: "100%",
            marginTop: 8,
            height: 44,
            fontSize: 16,
            borderRadius: 8,
            border: "1.5px solid #2984e4"
          }}
        >
          <option value="">Choose a job...</option>
          {jobs.map((job) => (
            <option
              key={job.jobid || job._id}
              value={job.jobid || job._id}
            >
              {job.jobid} - {job.jobrole || job.title || job.jobTitle}
            </option>
          ))}
        </select>
      </div>

      {/* Drag and Drop/upload area (whole area clickable) */}
      <div
        onDrop={onDrop}
        onDragOver={e => { e.preventDefault(); setDragActive(true); }}
        onDragLeave={() => setDragActive(false)}
        onClick={() => inputRef.current && inputRef.current.click()}
        style={{
          border: dragActive ? "2px dashed #167ff0" : "2px dashed #badafb",
          background: dragActive ? "#f0f8ff" : "#f9fcff",
          borderRadius: 11,
          height: 220,
          textAlign: "center",
          padding: 0,
          marginBottom: 30,
          transition: "border 0.2s, background 0.2s",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-end",
          cursor: "pointer",
          position: "relative",
          minWidth: 900,
          maxWidth: 540,
          marginLeft: "auto",
          marginRight: "auto"
        }}
      >
        {/* Hidden file input */}
        <input
          ref={inputRef}
          type="file"
          accept=".pdf,.doc,.docx"
          style={{ display: "none" }}
          id="resume-upload"
          onChange={handleFileChange}
        />
        <div style={{ flex: 1 }} />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 600,
            fontSize: 17,
            marginBottom: 95,
            color: "#2684ff",
            userSelect: "none",
            cursor: "default",
          }}
        >
          {resumeFile ? (
            <>
              <span style={{ flexGrow: 1, textAlign: "center" }}>
                Selected: {resumeFile.name}
              </span>
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  setResumeFile(null);
                }}
                style={{
                  background: "transparent",
                  border: "none",
                  color: "#fc0303ff",
                  fontWeight: "bold",
                  fontSize: 25,
                  marginLeft: 18,
                  cursor: "pointer",
                  userSelect: "none",
                  padding: 0,
                  lineHeight: 1,
                }}
                aria-label="Clear selected file"
              >
                ×
              </button>
            </>
          ) : (
            "Drag & drop your resume here or click to upload"
          )}
        </div>
      </div>

      <button
        type="submit"
        disabled={!selectedJobId || !resumeFile || (loadingPhase > 0 && loadingPhase < 3)}
        style={{
          width: "100%",
          height: 48,
          borderRadius: 8,
          border: "none",
          background:
            !selectedJobId || !resumeFile || (loadingPhase > 0 && loadingPhase < 3)
              ? "#a3cdfb"
              : getLoadingColor(),
          color: "#fff",
          fontWeight: 700,
          fontSize: 17,
          cursor:
            !selectedJobId || !resumeFile || (loadingPhase > 0 && loadingPhase < 3)
              ? "not-allowed"
              : "pointer",
        }}
        onClick={handleSubmit}
      >
        {loadingPhase === 0 && "Submit"}
        {loadingPhase === 3 && "Completed"}
      </button>

      {message && (
        <div style={{ marginTop: 12, fontWeight: 600, color: getLoadingColor() }}>
          {message}
        </div>
      )}
    </div>
  );
}
